const accountNumberRegex = /^\d{1,17}$/;
const routingNumberRegex = /^(?!0+$)\d{8,9}$/;
const bicRegex = /^[A-Za-z]{4}(AT|at|At|aT|DE|de|De|dE|IT|it|It|iT)(\w{2}|\w{5})$/;
const ibanRegex = /^(AT|at|At|aT|DE|de|De|dE|IT|it|It|iT)\w{13,40}$/;

const validateAccountNumber = number => accountNumberRegex.test(number);

const validateRoutingNumber = number => routingNumberRegex.test(number);

const validateBIC = bic => bicRegex.test(bic);

const validateIBAN = iban => ibanRegex.test(iban);

const bicValidator = (i18n, value) => {
  if (!validateBIC(value)) {
    return i18n('checkout.lib.components.payment.echeck.eudd.valid.bic');
  }
  return '';
};

const ibanValidator = (i18n, value) => {
  if (!validateIBAN(value)) {
    return i18n('checkout.lib.components.payment.echeck.eudd.valid.iban');
  }
  return '';
};

const accountNumberValidator = (i18n, value) => {
  if (!validateAccountNumber(value)) {
    return i18n('checkout.lib.components.payment.echeck.ecp.valid.account.number');
  }
  return '';
};

const routingNumberValidator = (i18n, value) => {
  if (!validateRoutingNumber(value)) {
    return i18n('checkout.lib.components.payment.echeck.ecp.valid.routing.number');
  }
  return '';
};

export {
  bicValidator,
  ibanValidator,
  accountNumberValidator,
  routingNumberValidator,
};
